import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const RootSupervisor = () => {
    const { type } = useSelector(state => state.auth);
    return type === 'supervisor' || type === 'root' ? <Outlet /> : <Navigate to={'/login'} />
}

export default RootSupervisor;